import {gql} from '@apollo/client';

export const exchangeRatesUpdate = gql`
  mutation ExchangeRatesUpdate($input: ExchangeRateUpdateInput!) {
    exchangeRateUpdate(input: $input) {
      _id
      value
      sourceCurrency
      targetCurrency
      validFrom
      validTo
    }
  }
`;
